import styled from 'styled-components';

interface IProps {
  inverse?: boolean;
  surface?: number;
}

export const CardFooter = styled.div<IProps>`
  padding: 5px;
  border-top: 1px solid
    ${(props: IProps): string =>
      props.inverse
        ? 'var(--color-separator-inverse)'
        : 'var(--color-separator)'};
  display: flex;
  align-items: center;
  flex: 0;
  flex-direction: row;
  min-height: min-content;
  margin: auto 0px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${(props: IProps): string =>
    Number(props.surface)
      ? `var(--color-surface-${props.surface})`
      : 'transparent'};
`;

export const CardFooterLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const CardFooterRight = styled.div`
  flex: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
